/* HAVITA media delivery v1.0.0. Preserve the poster until a decoded frame exists. */
(() => {
  if (window.hvClosingVideo) {
    window.hvClosingVideo.scan(document);
    return;
  }

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const supportsObserver = 'IntersectionObserver' in window;
  let nearObserver;
  let visibleObserver;

  function sync(video, state) {
    if (document.hidden || motion.matches || !state.visible || !state.near) video.pause();
    if (motion.matches) video.classList.remove('is-ready');
    if (document.hidden || motion.matches || !state.near) return;

    if (!state.loaded) {
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
      });
      state.loaded = true;
      video.preload = 'auto';
      video.load();
    }
    if (state.visible && !state.failed) {
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {
        video.classList.remove('is-ready');
      });
    }
  }

  function onIntersection(entries, key) {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (!state) return;
      state[key] = entry.isIntersecting;
      sync(entry.target, state);
    });
  }

  function checkPositions() {
    states.forEach((state, video) => {
      const rect = video.getBoundingClientRect();
      state.near = rect.top < window.innerHeight * 2 && rect.bottom > -window.innerHeight;
      state.visible = rect.top < window.innerHeight && rect.bottom > 0;
      sync(video, state);
    });
  }

  function scan(root) {
    root.querySelectorAll('video[data-hv-deferred-video]').forEach(video => {
      if (states.has(video)) return;
      const state = { near: false, visible: false, loaded: false, failed: false };
      states.set(video, state);
      state.reveal = () => {
        if (!motion.matches && !state.failed && video.readyState >= 2) video.classList.add('is-ready');
      };
      state.error = () => { state.failed = true; video.classList.remove('is-ready'); };
      video.addEventListener('loadeddata', state.reveal);
      video.addEventListener('playing', state.reveal);
      video.addEventListener('error', state.error);
      if (supportsObserver) {
        nearObserver.observe(video);
        visibleObserver.observe(video);
      }
    });
    // Also handles restored scroll positions before observer delivery.
    checkPositions();
  }

  if (supportsObserver) {
    nearObserver = new IntersectionObserver(entries => onIntersection(entries, 'near'), {
      rootMargin: `${window.innerHeight}px 0px`
    });
    visibleObserver = new IntersectionObserver(entries => onIntersection(entries, 'visible'));
  } else {
    window.addEventListener('scroll', checkPositions, { passive: true });
  }
  window.addEventListener('resize', checkPositions, { passive: true });
  document.addEventListener('visibilitychange', checkPositions);
  if (motion.addEventListener) motion.addEventListener('change', checkPositions);
  else if (motion.addListener) motion.addListener(checkPositions);

  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, video) => {
      if (!event.target.contains(video)) return;
      video.pause();
      if (supportsObserver) {
        nearObserver.unobserve(video);
        visibleObserver.unobserve(video);
      }
      video.removeEventListener('loadeddata', state.reveal);
      video.removeEventListener('playing', state.reveal);
      video.removeEventListener('error', state.error);
      states.delete(video);
    });
  });
  window.hvClosingVideo = { scan };
  scan(document);
})();
